import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractOperator } from "../_types/contract-operator";

@Injectable({
    providedIn: 'root',
})
export class ContractOperatorsService extends Service<ContractOperator> {
  public override type = 'contractOperators';  
  public override url = 'attendance/contractOperators'; 
}
